var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunitiesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 17.6H11V10.9362L6.6 7.0994L2.2 10.9362V17.6H5.5V13.2H7.7V17.6ZM20.9 19.8H1.1C0.808262 19.8 0.528472 19.6841 0.322183 19.4778C0.115892 19.2715 6.58573e-09 18.9917 6.58573e-09 18.7V10.4357C-1.71917e-05 10.2785 0.03365 10.1232 0.0987335 9.9801C0.163817 9.83703 0.258805 9.70957 0.3773 9.6063L4.4 6.0984V1.1C4.4 0.808262 4.51589 0.528472 4.72218 0.322182C4.92847 0.115892 5.20826 0 5.5 0H20.9C21.1917 0 21.4715 0.115892 21.6778 0.322182C21.8841 0.528472 22 0.808262 22 1.1V18.7C22 18.9917 21.8841 19.2715 21.6778 19.4778C21.4715 19.6841 21.1917 19.8 20.9 19.8ZM15.4 8.8V11H17.6V8.8H15.4ZM15.4 13.2V15.4H17.6V13.2H15.4ZM15.4 4.4V6.6H17.6V4.4H15.4ZM11 4.4V6.6H13.2V4.4H11Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunitiesIcon);
export default __webpack_public_path__ + "static/media/communitiesIcon.370ab0156303de6543a99005d5ba8f7b.svg";
export { ForwardRef as ReactComponent };